/* eslint-disable lines-around-comment */
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { isDisplayNameVisible } from '../../../base/config/functions.any';
import { getLocalParticipant, getParticipantDisplayName, isWhiteboardParticipant } from '../../../base/participants/functions';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
// @ts-ignore
import { getLargeVideoParticipant } from '../../../large-video/functions';
import { isToolboxVisible } from '../../../toolbox/functions.web';
// @ts-ignore
import { isLayoutTileView } from '../../../video-layout';
import DisplayNameBadge from './DisplayNameBadge';
const useStyles = makeStyles()((theme) => {
    return {
        badgeContainer: Object.assign(Object.assign({}, withPixelLineHeight(theme.typography.bodyShortRegularLarge)), { alignItems: 'center', display: 'inline-flex', justifyContent: 'center', marginBottom: theme.spacing(7), transition: 'margin-bottom 0.3s', pointerEvents: 'none', position: 'absolute', bottom: 0, left: 0, width: '100%', zIndex: 1 }),
        containerElevated: {
            marginBottom: theme.spacing(12)
        }
    };
});
/**
 * Component that renders the dominant speaker's name as a badge above the toolbar in stage view.
 *
 * @returns {ReactElement|null}
 */
const StageParticipantNameLabel = () => {
    const { classes, cx } = useStyles();
    const largeVideoParticipant = useSelector(getLargeVideoParticipant);
    const selectedId = largeVideoParticipant === null || largeVideoParticipant === void 0 ? void 0 : largeVideoParticipant.id;
    const nameToDisplay = useSelector((state) => getParticipantDisplayName(state, selectedId));
    const localParticipant = useSelector(getLocalParticipant);
    const localId = localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.id;
    const isTileView = useSelector(isLayoutTileView);
    const toolboxVisible = useSelector(isToolboxVisible);
    const showDisplayName = useSelector(isDisplayNameVisible);
    if (showDisplayName
        && nameToDisplay
        && selectedId !== localId
        && !isTileView
        && !isWhiteboardParticipant(largeVideoParticipant)) {
        return (React.createElement("div", { className: cx('stage-participant-label', classes.badgeContainer, toolboxVisible && classes.containerElevated) },
            React.createElement(DisplayNameBadge, { name: nameToDisplay })));
    }
    return null;
};
export default StageParticipantNameLabel;
